import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConfirmationModule } from 'src/app/shared/modules/confirmation/confirmation.module';
import { ConfirmationBDPComponent } from './confirmation-bdp.component';

@NgModule({
    imports: [CommonModule, ConfirmationModule],
    declarations: [ConfirmationBDPComponent],
})
export class ConfirmationBDPModule {}
